/*!
 * Copyright © 2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { VirtualScrollViewportResizeDirective } from '../shared';

@NgModule({
  imports: [CommonModule, ScrollingModule],
  declarations: [VirtualScrollViewportResizeDirective],
  exports: [VirtualScrollViewportResizeDirective]
})
export class VirtualScrollViewportResizeModule {}
